import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const SelectShell = styled.div`
  & > * {
    background: ${semantic.bg.canvas};
    border-radius: ${size.radius['radius-md']};
  }
`;

export const FixedField = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: calc(${primitives.size['size-1000']} + ${space['space-400']} * 2);
  padding: ${space['space-400']} ${space['space-500']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-md']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${semantic.text.primary};
`;
